/* eslint-disable @typescript-eslint/tslint/config */
import { EnumerationItem, ValueLabelItem } from './enum-item.class';
import { dependencies } from './workflow.dependency';
import { PrimitiveType } from './workflow.type';

/**
 * A custom enumeration item that override the label and value of the based EnumerationItem
 * Should expose value, human readable label
 */
export class CustomEnumerationItem extends EnumerationItem {
  constructor(
    public readonly enumId: string,
    public readonly customLabel: string,
    private customValue: PrimitiveType,
    private readonly iterationId?: number,
    private readonly pageIterationId?: number,
    public readonly data?: ValueLabelItem
  ) {
    super(enumId, customValue);
  }

  /**
   * Human readable label
   */
  public get label(): string {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return <string>dependencies.stringVariableService.parse(this.customLabel, this.iterationId, this.pageIterationId);
  }

  /**
   * Parsed enumeration Value
   */
  public get value(): PrimitiveType {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return <string>dependencies.stringVariableService.parse(this.customValue, this.iterationId, this.pageIterationId);
  }

  public set value(value) {
    this.customValue = value;
  }
}
